import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ClientDataService } from '../auth/client.data.service';
import { ConfigService } from '../config/config.service';

interface WdtkEvent {
  params: {
    param: string;
    valueData: string;
  }[];
}

@Injectable({
  providedIn: 'root',
})
export class RestclientService {
  constructor(
    private httpclient: HttpClient,
    private clientData: ClientDataService,
    private configService: ConfigService
  ) {


  }
  /*
  private loat_web_backend_profile = endpoints.loat_web_backend + endpoints.profile;
  private loat_web_backend_facility_list = endpoints.loat_web_backend + endpoints.facility_list;
  private loat_web_backend_table_config = endpoints.loat_web_backend + endpoints.table_config;
  private loat_web_backend_main_list = endpoints.loat_web_backend + endpoints.main_list;
  private loat_web_backend_secondary_list = endpoints.loat_web_backend + endpoints.secondary_list;
  private loat_web_backend_typ_config = endpoints.loat_web_backend + endpoints.typ_config;
  private loat_web_backend_user_typ = endpoints.loat_web_backend + endpoints.user_typ;
  private loat_web_backend_event_list_send = endpoints.loat_web_backend + endpoints.event_list_send;
  private loat_web_backend_event_list_accept = endpoints.loat_web_backend + endpoints.event_list_accept;
  private loat_web_backend_event_list_undo = endpoints.loat_web_backend + endpoints.event_list_undo;
  private loat_web_backend_event_list_notifications = endpoints.loat_web_backend + endpoints.event_list_notifications;
  private loat_web_backend_segedit_notifications = endpoints.loat_web_backend + endpoints.event_segedit_notifications;
  private loat_web_backend_segedit_profile = endpoints.loat_web_backend + endpoints.segedit_profile;
  */

  private loat_web_backend_profile = this.configService.profile;
  private loat_web_backend_facility_list = this.configService.facilityList;
  private loat_web_backend_table_config = this.configService.tableConfig;
  private loat_web_backend_main_list = this.configService.mainList;
  private loat_web_backend_secondary_list = this.configService.secondaryList;
  private loat_web_backend_typ_config = this.configService.typConfig;
  private loat_web_backend_user_typ = this.configService.userTyp;
  private loat_web_backend_event_list_send = this.configService.eventListSend;
  private loat_web_backend_event_list_accept = this.configService.eventListAccept;
  private loat_web_backend_event_list_undo = this.configService.eventListUndo;
  private loat_web_backend_event_list_notifications = this.configService.eventListNotifications;
  private loat_web_backend_segedit_notifications = this.configService.eventSegeditNotifications;
  private loat_web_backend_segedit_profile = this.configService.segeditProfile;

  public getUserPrivileges() {
    this.httpclient.get<any>(this.loat_web_backend_profile).subscribe(
      (result) => {
        //console.log(result);
        for (let facilityResult of result) {
          this.clientData.facility_priviledge.push({
            id_facility: facilityResult.id_facility,
            id_privileges: facilityResult.id_privileges,
            default: facilityResult.default,
          });
        }

        //console.log(this.loggedUser.facility_priviledge);
        return result;
      },
      (error) => {
        console.error(error);
        return null;
      }
    );
  }

  public getUIXFacilityList() {
    //console.log('ejecutando getUIXFacilityList');
    return this.httpclient.get<any>(this.loat_web_backend_facility_list);
  }

  public getEventTableConfig() {
    //console.log('ejecutando getEventTableConfig');
    return this.httpclient.get<any>(this.loat_web_backend_table_config);
  }

  public getMainEventTableData() {
    //console.log('ejecutando getMainEventTableData');

    let activeFacility;
    for (let i = 0; i < this.clientData.uix_facility_list.length; i++) {
      if (this.clientData.uix_facility_list[i]['active'] == 1) {
        activeFacility = this.clientData.uix_facility_list[i];
        //console.log('planta activa encontrada');
        //console.log(activeFacility);
        break;
      }
    }

    //console.log(this.loat_web_backend_main_list + '/' + activeFacility.id_facility);

    return this.httpclient.get<any>(
      this.loat_web_backend_main_list + '/' + activeFacility.id_facility
    );
  }

  public getSecondaryEventTableData() {
    //console.log('ejecutando getMainEventTableData');
    let activeFacility;
    for (let i = 0; i < this.clientData.uix_facility_list.length; i++) {
      if (this.clientData.uix_facility_list[i]['active'] == 1) {
        activeFacility = this.clientData.uix_facility_list[i];
        break;
      }
    }

    //console.log(this.loat_web_backend_secondary_list + '/' + activeFacility.id_facility);

    return this.httpclient.get<any>(
      this.loat_web_backend_secondary_list + '/' + activeFacility.id_facility
    );
  }

  /*
  saveUser(user, password){
    this.httpclient.post<any>(this.loat_web_backend_users, { user: user , password: this.loginservice.encryptPassword(password)}).subscribe();
  }
  */

  getTypConfig() {
    let activeFacility;
    for (let i = 0; i < this.clientData.uix_facility_list.length; i++) {
      if (this.clientData.uix_facility_list[i]['active'] == 1) {
        activeFacility = this.clientData.uix_facility_list[i];
        break;
      }
    }
    return this.httpclient.get<any>(
      this.loat_web_backend_typ_config + '/' + activeFacility.id_facility
    );
  }

  getTypData(importedWdtkEvent) {
    /*
    for local testing....
    return this.httpclient
    .get<any>(
      "http://localhost:3000/xmlreader/xml"
    )
    */

    //console.log(importedWdtkEvent.params);

    let id_event;
    for (let data of importedWdtkEvent.params) {
      //console.log(data);
      //console.log(data.param);
      if (data.param === 'event_id') {
        id_event = data.valueData;
        break;
      }
    }

    //console.log(eventId);

    let activeFacility;
    for (let i = 0; i < this.clientData.uix_facility_list.length; i++) {
      if (this.clientData.uix_facility_list[i]['active'] == 1) {
        activeFacility = this.clientData.uix_facility_list[i];
        break;
      }
    }

    //let enviroments = endpoints.typ_data_enviroment;
    let enviroments = this.configService.typDataEnvironment;
    //console.log(enviroments);
    for (let enviroment of enviroments) {
      if (enviroment.active == true) {
        return this.httpclient.get<any>(
          this.loat_web_backend_user_typ +
            '/' +
            enviroment.url +
            '/' +
            activeFacility.id_facility +
            '/' +
            id_event
        );

        /*
        if(enviroment.mode === 'locale')
        {
          
          return this.httpclient
          .get<any>(
            enviroment.url + '/' + eventId
          )
          return this.httpclient
          .get<any>(
            enviroment.url + '/' + activeFacility.id_facility + '/' +  eventId
          )
        }
        if(enviroment.mode === 'remote')
        {
          return this.httpclient
          .get<any>(
            enviroment.url + '/' + activeFacility.id_facility + '/' +  eventId
          )
        }
        */
      }
    }
  }

  postTypData(importedWdtkEvent, user_typ_data) {
    let activeFacility;
    for (let i = 0; i < this.clientData.uix_facility_list.length; i++) {
      if (this.clientData.uix_facility_list[i]['active'] == 1) {
        activeFacility = this.clientData.uix_facility_list[i];
        break;
      }
    }

    let id_event;
    for (let data of importedWdtkEvent.params) {
      if (data.param === 'event_id') {
        id_event = data.valueData;
        break;
      }
    }

    //let enviroments = endpoints.typ_data_enviroment;
    let enviroments = this.configService.typDataEnvironment;
    for (let enviroment of enviroments) {
      if (enviroment.active == true) {
        return this.httpclient.post<any>(this.loat_web_backend_user_typ, {
          ambient: enviroment.mode,
          acronym_facility: activeFacility.acronym,
          id_event: id_event,
          user_typ_data: user_typ_data,
          id_facility : activeFacility.id_facility
        });
      }
    }

    //return this.httpclient.post<any>(this.loat_web_backend_user_typ, {id_facility : activeFacility.acronym, id_event: eventId, user_typ_data : user_typ_data});
  }

  unlockEvent(importedWdtkEvent: WdtkEvent) {
    let activeFacility;
    for (let i = 0; i < this.clientData.uix_facility_list.length; i++) {
      if (this.clientData.uix_facility_list[i]['active'] == 1) {
        activeFacility = this.clientData.uix_facility_list[i];
        break;
      }
    }

    let id_event: string;
    for (let data of importedWdtkEvent.params) {
      if (data.param === 'event_id') {
        id_event = data.valueData;
        break;
      }
    }

    let url = this.loat_web_backend_user_typ + '/unlock';

    return this.httpclient.post<any>(url, {
      id_facility: activeFacility.id_facility,
      id_event: id_event,
    });
  }

  postAcceptEvent(importedWdtkEvent) {
    let activeFacility;
    for (let i = 0; i < this.clientData.uix_facility_list.length; i++) {
      if (this.clientData.uix_facility_list[i]['active'] == 1) {
        activeFacility = this.clientData.uix_facility_list[i];
        break;
      }
    }

    let id_event;
    for (let data of importedWdtkEvent.params) {
      if (data.param === 'event_id') {
        id_event = data.valueData;
        break;
      }
    }

    let url = this.loat_web_backend_event_list_accept;

    return this.httpclient.post<any>(url, {
      id_facility: activeFacility.id_facility,
      id_event: id_event,
    });
  }

  postUndoEvent(importedWdtkEvent) {
    let activeFacility;
    for (let i = 0; i < this.clientData.uix_facility_list.length; i++) {
      if (this.clientData.uix_facility_list[i]['active'] == 1) {
        activeFacility = this.clientData.uix_facility_list[i];
        break;
      }
    }

    let id_event;
    for (let data of importedWdtkEvent.params) {
      if (data.param === 'event_id') {
        id_event = data.valueData;
        break;
      }
    }

    let url = this.loat_web_backend_event_list_undo;

    return this.httpclient.post<any>(url, {
      id_facility: activeFacility.id_facility,
      id_event: id_event,
    });
  }

  postSendEvent(importedWdtkEvent) {
    let activeFacility;
    for (let i = 0; i < this.clientData.uix_facility_list.length; i++) {
      if (this.clientData.uix_facility_list[i]['active'] == 1) {
        activeFacility = this.clientData.uix_facility_list[i];
        break;
      }
    }

    let id_event;
    for (let data of importedWdtkEvent.params) {
      if (data.param === 'event_id') {
        id_event = data.valueData;
        break;
      }
    }

    let url = this.loat_web_backend_event_list_send;

    return this.httpclient.post<any>(url, {
      id_facility: activeFacility.id_facility,
      id_event: id_event,
    });
  }

  getNotifications(eventListTimestamp) {
    return this.httpclient.get<any>(
      this.loat_web_backend_event_list_notifications +
        '/' +
        this.getActiveFacility().id_facility +
        '/' +
        eventListTimestamp
    );
  }

  getActiveFacility() {
    let activeFacility;
    for (let i = 0; i < this.clientData.uix_facility_list.length; i++) {
      if (this.clientData.uix_facility_list[i]['active'] == 1) {
        activeFacility = this.clientData.uix_facility_list[i];
        break;
      }
    }
    return activeFacility;
  }

  public segEditProfile() {
    const headers = new HttpHeaders().set(
      'Content-Type',
      'application/json; charset=utf-8'
    );
    console.log("creating temp segedit profile", this.getActiveFacility().id_facility);
    return this.httpclient.post<any>(
      this.loat_web_backend_segedit_profile,
      { facilityId: this.getActiveFacility().id_facility },
      { headers: headers }
    );
  }

  getSegeditNotifications(eventId) {
    return this.httpclient.get<any>(
      this.loat_web_backend_segedit_notifications +
        '/' +
        this.getActiveFacility().id_facility +
        '/' +
        eventId
    );
  }
}
